import moment from "moment";

import {
  Badge,
  CopyButton,
  CurrencyDisplay,
  SwitchAppButton,
} from "../../../../components";
import { appConfig } from "../../../../configs";
import { transferStatus, transferTypes } from "../../../../enums";
import { IViewSingleTransfer } from "../../../../interfaces-and-types";
import {
  getTransferStatusIndicator,
  truncateStringWithEllipsis,
} from "../../../../utils";

import receiptIcon from "../../../../assets/icons/document-text.svg";

export const singleTransferDisplayFormatter = (item: IViewSingleTransfer) => {
  const statusIndicator = getTransferStatusIndicator(item);

  const isBankTransfer = item.transfer_type === transferTypes.bank;
  const recipientAccountOrMerchantName = isBankTransfer
    ? item.account_name
    : item.destination_gateway_merchant_name;
  const recipientAccountNoOrId = isBankTransfer
    ? item.account_number
    : item.destination_gateway_merchant_id;
  const recipientBankOrGatewayName = isBankTransfer
    ? item.bank_name
    : item.destination_gateway_name;
  const recipientBankOrGatewayCode = isBankTransfer
    ? item.bank_code
    : item.destination_gateway_code;

  return {
    ...item,
    amount: (
      <CurrencyDisplay currencyOrSymbol={item.currency} amount={item.amount} />
    ),
    transfer_fee: (
      <CurrencyDisplay
        currencyOrSymbol={item.currency}
        amount={item.transfer_fee}
      />
    ),
    rate: (
      <CurrencyDisplay
        currencyOrSymbol={item.source_currency}
        amount={item.rate}
      />
    ),
    account_name: (
      <strong title={recipientAccountOrMerchantName}>
        {truncateStringWithEllipsis(recipientAccountOrMerchantName, 30)}
      </strong>
    ),
    account_number: <strong>{recipientAccountNoOrId}</strong>,
    bank_name: (
      <strong title={recipientBankOrGatewayName}>
        {truncateStringWithEllipsis(recipientBankOrGatewayName, 30)}
      </strong>
    ),
    bank_code: recipientBankOrGatewayCode,
    session_id: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="session-id-text modal-header--title">
          <span
            className="transfer-description truncate-text--ellipsis"
            title={item.session_id}
          >
            {truncateStringWithEllipsis(item.session_id, 8)}
          </span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            stringToCopy={item.session_id}
            iconDescription="copy bank transfer session id"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    status: (
      <Badge text={item.status} statusColor={statusIndicator.statusType} />
    ),
    created_at: (
      <span className="date--oneline">
        {moment(item.created_at).format(appConfig.dateTimeFormat)}
      </span>
    ),
    paid_at:
      item.status !== transferStatus.successful ? (
        "-"
      ) : (
        <span className="date--oneline">
          {moment(item.paid_at).format(appConfig.dateTimeFormat)}
        </span>
      ),
    // more: <OverflowMenuDropDown />,
    viewReceipt: (
      <SwitchAppButton
        onClick={() => {}}
        size="sm"
        kind="tertiary"
        className="no-padding"
        title="View/Download Receipt"
      >
        <img src={receiptIcon} alt="download receipt" />
      </SwitchAppButton>
    ),
  };
};
